import React from "react";

import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import WeeklyRatingGraph from "./WeeklyRatingGraph";
import WeeklyRatingGraphLegends from "./WeeklyRatingGraphLegends";

const useStyles = makeStyles()(() => ({
  weeklyRating: {
    color: "#363E45",
    fontFamily: "Mulish",
    fontSize: 20,
    fontWeight: 700,
  },
  weeklyRatingGraphContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  legend: {
    color: "#4C515A",
    fontFamily: "Mulish",
    fontSize: 14,
    fontWeight: 700,
  },
  ratingIcon: {
    height: 24,
    width: 24,
  },
}));

const WeeklyRating: React.FC = () => {
  const { classes } = useStyles();

  return (
    <Box padding={4}>
      <Typography className={classes.weeklyRating}>Weekly Rating</Typography>
      <Box height={24} />
      <Box className={classes.weeklyRatingGraphContainer}>
        <Typography className={classes.legend}>Legend</Typography>
        <Box width={8} />
        <WeeklyRatingGraphLegends />
      </Box>
      <WeeklyRatingGraph />
    </Box>
  );
};

export default WeeklyRating;
